var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDuration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.042,
    height: 7.042,
    viewBox: "0 0 7.042 7.042",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "customFill",
    id: "Icon_material-timelapse",
    "data-name": "Icon material-timelapse",
    d: "M8.014,5.028a2.1,2.1,0,0,0-1.493-.62V6.521L5.028,8.014A2.111,2.111,0,1,0,8.014,5.028ZM6.521,3a3.521,3.521,0,1,0,3.521,3.521A3.522,3.522,0,0,0,6.521,3Zm0,6.338A2.817,2.817,0,1,1,9.338,6.521,2.816,2.816,0,0,1,6.521,9.338Z",
    transform: "translate(-3 -3)",
    fill: "rgba(0,0,0,0.64)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDuration);
export default __webpack_public_path__ + "static/media/icon-duration.56deae038fbf8fbec0971618b5d3f5dd.svg";
export { ForwardRef as ReactComponent };